// Mock data for KWE Gebäudetechnik website

export const services = [
  {
    id: 1,
    title: 'Heizungstechnik',
    description: 'Moderne Heizsysteme und Wärmepumpen für effiziente Wärmeversorgung',
    icon: 'Flame',
    image: 'https://images.pexels.com/photos/20046689/pexels-photo-20046689.jpeg'
  },
  {
    id: 2,
    title: 'Lüftungstechnik',
    description: 'Lufttechnische Anlagen für optimales Raumklima',
    icon: 'Wind',
    image: 'https://images.unsplash.com/photo-1574334292321-4844f63aefef'
  },
  {
    id: 3,
    title: 'Klimatechnik',
    description: 'Professionelle Klimaanlagen und Kältetechnik',
    icon: 'Snowflake',
    image: 'https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxIVkFDJTIwc3lzdGVtfGVufDB8fHx8MTc4NDA2MTQwMHww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 4,
    title: 'Sanitärtechnik',
    description: 'Gas-, Wasser- und Sanitärinstallationen',
    icon: 'Droplets',
    image: 'https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg'
  },
  {
    id: 5,
    title: 'Elektrotechnik',
    description: 'Elektro- und Informationstechnik für moderne Gebäude',
    icon: 'Zap',
    image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a'
  }
];

export const projects = [
  {
    id: 1,
    title: 'Neubau Gewerbeimmobilie München',
    category: 'Gewerbe',
    description: 'Komplette Gebäudetechnik für modernes Bürogebäude',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800'
  },
  {
    id: 2,
    title: 'Wohnanlage Sendling',
    category: 'Wohnen',
    description: 'Heizung, Lüftung und Sanitär für 45 Wohneinheiten',
    image: 'https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800'
  }
];

export const companyInfo = {
  name: 'KWE Gebäudetechnik GmbH',
  address: 'Gollierplatz 8',
  city: '80339 München',
  managingDirector: 'Mustafa Yigit',
  tradeRegister: 'Amtsgericht München, HRB 293160',
  website: 'kwe-gbt.de',
  phone: '+49 89 12345678',
  email: 'info@kwe-gbt.de',
  description: 'KWE Gebäudetechnik ist Ihr kompetenter Partner für alle Bereiche der modernen Gebäudetechnik in München und Umgebung. Mit langjähriger Erfahrung und hochqualifizierten Fachkräften realisieren wir Projekte jeder Größenordnung – von der Planung bis zur Inbetriebnahme.'
};

export const mockContactSubmission = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock Contact Form Submission:', formData);
      resolve({ success: true, message: 'Nachricht erfolgreich gesendet!' });
    }, 1000);
  });
};